"use client";
import React from "react";
import clsx from "clsx";
import Image from "next/image";

export default function HeroWithImage({ data, index = 1 }) {
  const {
    title,
    subtitle,
    buttons = [],
    badge,
    media,
    background = {},
    align = "left",
    padding = "xl",
  } = data || {};
  const bgStyle =
    background.type === "gradient"
      ? { backgroundImage: background.value }
      : background.type === "color"
        ? { backgroundColor: background.value }
        : background.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "enter",
            }
          : {};

  const isImageLeft = media?.position === "left";

  const paddingMap = {
    sm: "py-10 px-4",
    md: "py-16 px-6",
    lg: "py-20 px-6",
    xl: "py-28 px-8",
  };

  return (
    <section
      className={`${paddingMap[padding] || "py-20 px-6"}`}
      style={bgStyle}
    >
      <div
        className={clsx(
          "max-w-7xl mx-auto flex flex-col-reverse md:flex-row gap-10 items-center",
          {
            "md:flex-row-reverse": !isImageLeft,
          },
        )}
      >
        {/* Text content */}
        <div
          className={clsx(
            "w-full md:w-1/2",
            align === "center" ? "text-center" : "",
          )}
        >
          {badge && (
            <div className="inline-flex items-center mb-4 text-sm font-medium text-primary bg-blue-100 px-3 py-1 rounded-full">
              {badge.icon && (
                <img src={badge.icon} alt="icon" className="w-4 h-4 mr-2" />
              )}
              {badge.text}
            </div>
          )}
          {title && (
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">{title}</h1>
          )}
          {subtitle && <p className="text-lg text-gray-600 mb-6">{subtitle}</p>}
          {buttons?.length > 0 && (
            <div className="flex gap-4 flex-wrap justify-center md:justify-start">
              {buttons.map((btn, idx) => (
                <a
                  key={idx}
                  href={btn.href}
                  className={`px-5 py-3 rounded-lg text-sm font-medium transition ${
                    btn.style === "secondary"
                      ? "bg-white text-gray-800 border border-gray-300 hover:bg-gray-100"
                      : btn.style === "ghost"
                        ? "bg-transparent text-gray-700 hover:underline"
                        : "bg-primary text-white hover:bg-secondary"
                  }`}
                >
                  {btn.text}
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Media */}
        {media?.src && media?.type === "image" && (
          <div className="bg-secondary-foreground rounded-xl w-full md:w-1/2 relative aspect-4/3">
            <Image
              src={media.src}
              alt={media.alt || title || "Hero image"}
              fill={true}
              priority={index === 0}
              sizes="(max-width: 640px) 50vw, (max-width: 1200px) 30vw, 20vw"
              className="w-full h-auto rounded-xl shadow-md object-cover"
            />
          </div>
        )}
      </div>
    </section>
  );
}
